<template>
  <div class="c-thumb-links" :class="wrapperClass">
    <div v-show="false" class="c-thumb-links__slot">
      <slot></slot>
    </div>
    <nav class="c-thumb-links__nav" v-if="list.length > 2">
      <button class="c-thumb-links__nav-button" @click="prev"><e-icon name="chevron-left"></e-icon></button>
      <button class="c-thumb-links__nav-button" @click="next"><e-icon name="chevron-right"></e-icon></button>
    </nav>
    <div class="c-thumb-links__inner">
      <ul class="c-thumb-links__list" :style="listStyle">
        <li
          v-for="(item, index) in list"
          :key="index"
          class="c-thumb-links__item"
        >
          <a :href="item.href" v-background="item.thumb">
            <span class="c-thumb-links__caption" v-html="item.caption"></span>
          </a>
          <p class="c-thumb-links__description" v-if="item.description" v-html="item.description"></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import Icon from "../element/icon.vue";
import u from "../lib/u";

export default {

  props: ["modifier"],

  components: {
    "e-icon": Icon
  },

  data (){
    return {
      state: false,
      mobile: false,
      index: 0,
      list: [],
      itemWidth: 410,
    }
  },

  computed: {
    wrapperClass (){
      let o = {};
      o["-active"] = this.state;
      o[this.modifier] = true;
      return o;
    },

    listStyle (){
      const pos = (this.index * this.itemWidth);
      return {
        transform: `translateX(-${pos}px)`
      };
    },

    slide (){
      return $(this.$el).find(".c-thumb-links__inner").eq(0);
    },

    positions (){
      const col = $(window).width() * 0.51;
      let positions = [];
      this.list.map((item, i) => {
        positions.push(parseInt(i * col, 10));
      });
      return positions;
    }
  },

  mounted (){
    this.list = Array.from(this.$el.querySelectorAll(".c-thumb-links__slot li"))
    .map((el) => {
      return {
        href: u.exists(el.querySelector("a"), "href"),
        thumb: u.exists(el.querySelector("img"), "src"),
        caption: u.exists(el.querySelector(".caption"), "innerHTML"),
        description: u.exists(el.querySelector(".description"), "innerHTML")
      };
      /*
      let a = el.querySelector("a");
      let img = el.querySelector("img");
      let caption = el.querySelector(".caption");
      let description = el.querySelector(".description");
      return {
        href: a ? a.href : null,
        thumb: img ? img.src : null,
        caption: caption ? caption.innerHTML : null,
        description: description ? description.innerHTML : null
      }
      */
    });

    this.mobile = ("ontouchstart" in window) && $(window).width() < 640;

    setTimeout(()=>{
      this.state = true;
    }, 100);
  },

  directives: {
    background (el, o){
      el.style.backgroundImage = `url(${o.value})`;
    }
  },

  methods: {
    next (){
      if(! this.mobile){
        const index = (this.index + 1) % (this.list.length - 1);
        this.index = index;
        return;
      }

      // 現在のスクロール位置から、次アイテムのスクロール位置を知る
      this.slide.animate({
        scrollLeft: u.getNext(this.slide.scrollLeft(), this.positions)
      }, 200);
    },
    prev (){
      if(! this.mobile){
        let index = this.index - 1;
        index = (index < 0) ? (this.list.length-2) : index;
        this.index = index;
        return;
      }

      this.slide.animate({
        scrollLeft: u.getPrev(this.slide.scrollLeft(), this.positions)
      }, 200);
    }
  }
  
}
</script>




// WEBPACK FOOTER //
// src/component/thumb-links.vue